import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('layout_layout_menu_data');

const Navdata = () => {
    const history = useNavigate();
    //state data
    const [isDashboard, setIsDashboard] = useState<boolean>(false);
    const [isApps, setIsApps] = useState<boolean>(false);
    const [isAuth, setIsAuth] = useState<boolean>(false);
    const [isPages, setIsPages] = useState<boolean>(false);
    const [isBaseUi, setIsBaseUi] = useState<boolean>(false);
    const [isAdvanceUi, setIsAdvanceUi] = useState<boolean>(false);
    const [isForms, setIsForms] = useState<boolean>(false);
    const [isTables, setIsTables] = useState<boolean>(false);
    const [isCharts, setIsCharts] = useState<boolean>(false);
    const [isIcons, setIsIcons] = useState<boolean>(false);
    const [isMaps, setIsMaps] = useState<boolean>(false);
    const [isMultiLevel, setIsMultiLevel] = useState<boolean>(false);
    const [isPayoutResults, setIsPayoutResults] = useState<boolean>(false);

    // Apps
    const [isCalendar, setCalendar] = useState<boolean>(false);
    const [isEmail, setEmail] = useState<boolean>(false);
    const [isSubEmail, setSubEmail] = useState<boolean>(false);
    const [isEcommerce, setIsEcommerce] = useState<boolean>(false);
    const [isProjects, setIsProjects] = useState<boolean>(false);
    const [isTasks, setIsTasks] = useState<boolean>(false);
    const [isCRM, setIsCRM] = useState<boolean>(false);
    const [isCrypto, setIsCrypto] = useState<boolean>(false);
    const [isInvoices, setIsInvoices] = useState<boolean>(false);
    const [isSupportTickets, setIsSupportTickets] = useState<boolean>(false);
    const [isNFTMarketplace, setIsNFTMarketplace] = useState<boolean>(false);
    const [isJobs, setIsJobs] = useState<boolean>(false);
    const [isJobList, setIsJobList] = useState<boolean>(false);
    const [isCandidateList, setIsCandidateList] = useState<boolean>(false);


    // Authentication
    const [isSignIn, setIsSignIn] = useState<boolean>(false);
    const [isSignUp, setIsSignUp] = useState<boolean>(false);
    const [isPasswordReset, setIsPasswordReset] = useState<boolean>(false);
    const [isPasswordCreate, setIsPasswordCreate] = useState<boolean>(false);
    const [isLockScreen, setIsLockScreen] = useState<boolean>(false);
    const [isLogout, setIsLogout] = useState<boolean>(false);
    const [isSuccessMessage, setIsSuccessMessage] = useState<boolean>(false);
    const [isVerification, setIsVerification] = useState<boolean>(false);
    const [isError, setIsError] = useState<boolean>(false);

    // Pages
    const [isProfile, setIsProfile] = useState<boolean>(false);
    const [isLanding, setIsLanding] = useState<boolean>(false);


    // Charts
    const [isApex, setIsApex] = useState<boolean>(false);

    // Multi Level
    const [isLevel1, setIsLevel1] = useState<boolean>(false);
    const [isLevel2, setIsLevel2] = useState<boolean>(false);

    const [iscurrentState, setIscurrentState] = useState('Dashboard');

    function updateIconSidebar(e: any) {
        if (e && e.target && e.target.getAttribute("sub-items")) {
            const ul: any = document.getElementById("two-column-menu");
            const iconItems: any = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");
                var id = item.getAttribute("sub-items");
                const getID = document.getElementById(id) as HTMLElement;
                if (getID)
                    getID.classList.remove("show");
            });
        }
    }

    useEffect(() => {
        document.body.classList.remove('twocolumn-panel');
        if (iscurrentState !== 'Dashboard') {
            setIsDashboard(false);
        }
        if (iscurrentState !== 'Apps') {
            setIsApps(false);
        }
        if (iscurrentState !== 'Auth') {
            setIsAuth(false);
        }
        if (iscurrentState !== 'Pages') {
            setIsPages(false);
        }
        if (iscurrentState !== 'BaseUi') {
            setIsBaseUi(false);
        }
        if (iscurrentState !== 'AdvanceUi') {
            setIsAdvanceUi(false);
        }
        if (iscurrentState !== 'Forms') {
            setIsForms(false);
        }
        if (iscurrentState !== 'Tables') {
            setIsTables(false);
        }
        if (iscurrentState !== 'Charts') {
            setIsCharts(false);
        }
        if (iscurrentState !== 'Icons') {
            setIsIcons(false);
        }
        if (iscurrentState !== 'Maps') {
            setIsMaps(false);
        }
        if (iscurrentState !== 'MuliLevel') {
            setIsMultiLevel(false);
        }
        if (iscurrentState === 'Widgets') {
            history("/widgets");
            document.body.classList.add('twocolumn-panel');
        }
        if (iscurrentState !== 'Landing') {
            setIsLanding(false);
        }
    }, [
        history,
        iscurrentState,
        isDashboard,
        isApps,
        isAuth,
        isPages,
        isBaseUi,
        isAdvanceUi,
        isForms,
        isTables,
        isCharts,
        isIcons,
        isMaps,
        isMultiLevel
    ]);

    const menuItems: any = [
        {
            label: st('menu_chinh_label'),
            isHeader: true,
        },
        {
            id: "home",
            label: st('trang_chu_label'),
            icon: "ri-home-5-line",
            link: "/dashboard",
            click: function (e: any) {
                e.preventDefault();
                setIscurrentState('Home');
            }
        },
        {
            id: "notifications",
            label: st('thong_bao_label'),
            icon: "ri-notification-3-line",
            link: "/notifications",
            click: function (e: any) {
                e.preventDefault();
                setIscurrentState('Notifications');
            }
        },
        {
            id: "ticket",
            label: st('quan_ly_phat_hanh_label'),
            icon: "ri-dashboard-2-line",
            link: "/#",
            stateVariables: isDashboard,
            click: function (e: any) {
                e.preventDefault();
                setIsDashboard(!isDashboard);
                setIscurrentState('Dashboard');
                updateIconSidebar(e);
            },
            subItems: [
                 {
                    id: "ticketDesignTemplate",
                    label: st('quan_ly_mau_thiet_ke_ve_label'),
                    icon: "ri-ticket-2-fill",
                    parentId: "ticket",
                    link: "/ticket-design-template",
                    click: function (e: any) {
                        e.preventDefault();
                        setIscurrentState('TicketDesignTemplate');
                    }
                },
                {
                    id: "ticketTypeManagement",
                    label: st('quan_ly_loai_ve_label'),
                    icon: "ri-price-tag-3-line",
                    parentId: "ticket",
                    link: "/ticket-type-management",
                    click: function (e: any) {
                        e.preventDefault();
                        setIscurrentState('TicketTypeManagement');
                    }
                },
                {
                    id: "issuancePlans",
                    label: st('ke_hoach_phat_hanh_label'),
                    icon: "ri-calendar-check-line",
                    parentId: "ticket",
                    link: "/issuance-plans",
                    click: function (e: any) {
                        e.preventDefault();
                        setIscurrentState('IssuancePlans');
                    }
                },
                {
                    id: "errorPlanManagement",
                    label: st('quan_ly_ke_hoach_loi_label'),
                    icon: "ri-error-warning-line",
                    parentId: "ticket",
                    link: "/error-plan-management",
                    click: function (e: any) {
                        e.preventDefault();
                        setIscurrentState('ErrorPlanManagement');
                    }
                },
                {
                    id: "printHouseDeliveries",
                    label: st('lich_su_giao_ve_nha_in_label'),
                    icon: "ri-truck-line",
                    parentId: "ticket",
                    link: "/print-house-deliveries",
                    click: function (e: any) {
                        e.preventDefault();
                        setIscurrentState('PrintHouseDeliveries');
                    }
                },
                {
                    id: "sinhBoSoQr",
                    label: st('sinh_bo_so_ma_qr_label'),
                    icon: "ri-qr-code-line",
                    parentId: "ticket",
                    link: "/sinh-bo-so-qr",
                    click: function (e: any) {
                        e.preventDefault();
                        setIscurrentState('SinhBoSoQr');
                    }
                },
                {
                    id: "ticketStockOverview",
                    label: st('ton_kho_ve_theo_ke_hoach_label'),
                    icon: "ri-archive-line",
                    parentId: "ticket",
                    link: "/ticket-stock-overview",
                    click: function (e: any) {
                        e.preventDefault();
                        setIscurrentState('TicketStockOverview');
                    }
                },
                {
                    id: "ticketManagement",
                    label: st('quan_ly_ve_label'),
                    icon: "ri-file-list-3-line",
                    parentId: "ticket",
                    link: "/ticket-management",
                    click: function (e: any) {
                        e.preventDefault();
                        setIscurrentState('TicketManagement');
                    }
                },
                // Thu hồi vé ế (REQUIRE_FIXBUGS.md mục 13.3) — trước đây chưa có mục menu nào - ADDED
                {
                    id: "ticketRecall",
                    label: st('thu_hoi_ve_e_label'),
                    icon: "ri-arrow-go-back-line",
                    parentId: "ticket",
                    link: "/ticket-recall",
                    click: function (e: any) {
                        e.preventDefault();
                        setIscurrentState('TicketRecall');
                    }
                },
                // Mục 8.3, README_UPDATE.md — giao vé bằng đọc mã QR qua ảnh - ADDED
                {
                    id: "ticketDeliveryQrScan",
                    label: st('giao_ve_bang_qr_label'),
                    icon: "ri-qr-code-line",
                    parentId: "ticket",
                    link: "/ticket-delivery-management/qr-scan",
                    click: function (e: any) {
                        e.preventDefault();
                        setIscurrentState('TicketDeliveryQrScan');
                    }
                },
                // Mục 8.3, README_UPDATE.md — thu hồi vé bằng đọc mã QR qua ảnh - ADDED
                {
                    id: "ticketRecallQrScan",
                    label: st('thu_hoi_ve_bang_qr_label'),
                    icon: "ri-qr-scan-2-line",
                    parentId: "ticket",
                    link: "/ticket-recall/qr-scan",
                    click: function (e: any) {
                        e.preventDefault();
                        setIscurrentState('TicketRecallQrScan');
                    }
                },
                // Duyệt thu hồi vé ế (mục 22/23, REQUIRE_FIXBUGS.md) - ADDED
                {
                    id: "unsoldTicketAppraisal",
                    label: st('duyet_thu_hoi_ve_e_label'),
                    icon: "ri-shield-check-line",
                    parentId: "ticket",
                    link: "/unsold-ticket-appraisal",
                    click: function (e: any) {
                        e.preventDefault();
                        setIscurrentState('UnsoldTicketAppraisal');
                    }
                },
                // Module báo cáo (mục 24, REQUIRE_FIXBUGS.md) — mục 14.b, README_UPDATE.md: tách
                // 3 menu riêng (trước đây 1 menu "Báo cáo" trỏ vào trang gộp tab).
                {
                    id: "reportIssuancePlan",
                    label: st('bao_cao_ky_phat_hanh_label'),
                    icon: "ri-bar-chart-2-line",
                    parentId: "ticket",
                    link: "/reports/issuance-plan",
                    click: function (e: any) {
                        e.preventDefault();
                        setIscurrentState('IssuancePlanReport');
                    }
                },
                {
                    id: "reportTicketDeliveryByAgent",
                    label: st('bao_cao_giao_ve_dai_ly_label'),
                    icon: "ri-bar-chart-2-line",
                    parentId: "ticket",
                    link: "/reports/ticket-delivery-by-agent",
                    click: function (e: any) {
                        e.preventDefault();
                        setIscurrentState('TicketDeliveryByAgentReport');
                    }
                },
                {
                    id: "reportTicketRecallByAgent",
                    label: st('bao_cao_thu_hoi_ve_e_label'),
                    icon: "ri-bar-chart-2-line",
                    parentId: "ticket",
                    link: "/reports/ticket-recall-by-agent",
                    click: function (e: any) {
                        e.preventDefault();
                        setIscurrentState('TicketRecallByAgentReport');
                    }
                },
                // dac-ta-bao-cao-cong-no-dai-ly.md — bao cao cong no dai ly (So cai) - ADDED
                {
                    id: "reportAgentDebt",
                    label: st('bao_cao_cong_no_dai_ly_label'),
                    icon: "ri-bar-chart-2-line",
                    parentId: "ticket",
                    link: "/reports/agent-debt",
                    click: function (e: any) {
                        e.preventDefault();
                        setIscurrentState('AgentDebtReport');
                    }
                },
                // §10 — dieu chinh cong no dai ly (quyen reports.debt-adjustment) - ADDED
                {
                    id: "reportAgentDebtAdjustment",
                    label: st('dieu_chinh_cong_no_dai_ly_label'),
                    icon: "ri-edit-2-line",
                    parentId: "ticket",
                    link: "/reports/agent-debt-adjustment",
                    click: function (e: any) {
                        e.preventDefault();
                        setIscurrentState('AgentDebtAdjustment');
                    }
                },
            ],
        },
        {
            id: "payoutResults",
            label: st('tra_thuong_ket_qua_label'),
            icon: "ri-trophy-line",
            link: "/#",
            stateVariables: isPayoutResults,
            click: function (e: any) {
                e.preventDefault();
                setIsPayoutResults(!isPayoutResults);
                setIscurrentState('PayoutResults');
                updateIconSidebar(e);
            },
            subItems: [
                // Prize Structure Management (Cơ cấu Giải thưởng) - ADDED
                {
                    id: "prizeStructure",
                    label: st('co_cau_giai_thuong_label'),
                    icon: "ri-trophy-line",
                    parentId: "payoutResults",
                    link: "/prize-structure",
                    click: function (e: any) {
                        e.preventDefault();
                        setIscurrentState('PrizeStructure');
                    }
                },
                // Draw Result Management (Kết quả Quay số) - ADDED
                {
                    id: "drawResult",
                    label: st('ket_qua_quay_so_label'),
                    icon: "ri-numbers-line",
                    parentId: "payoutResults",
                    link: "/draw-result",
                    click: function (e: any) {
                        e.preventDefault();
                        setIscurrentState('DrawResult');
                    }
                },
                // Prize Claim Dossier (Thẩm định Hồ sơ Trả thưởng) - ADDED
                {
                    id: "claimDossier",
                    label: st('tham_dinh_ho_so_label'),
                    icon: "ri-file-shield-2-line",
                    parentId: "payoutResults",
                    link: "/claim-dossiers",
                    click: function (e: any) {
                        e.preventDefault();
                        setIscurrentState('ClaimDossier');
                    }
                },
                // Hậu kiểm Trả thưởng (mục 7.2) — kết quả trả thưởng đã được admin thẩm định phê duyệt
                {
                    id: "claimDossierPostAudit",
                    label: st('hau_kiem_tra_thuong_label'),
                    icon: "ri-search-eye-line",
                    parentId: "payoutResults",
                    link: "/claim-dossier-post-audit",
                    click: function (e: any) {
                        e.preventDefault();
                        setIscurrentState('ClaimDossierPostAudit');
                    }
                },
                // Payment Accounting (Kế toán Chi trả) - ADDED
                {
                    id: "paymentAccounting",
                    label: st('ke_toan_chi_tra_label'),
                    icon: "ri-bank-card-line",
                    parentId: "payoutResults",
                    link: "/payment-accounting",
                    click: function (e: any) {
                        e.preventDefault();
                        setIscurrentState('PaymentAccounting');
                    }
                },
            ],
        },
        {
            label: st('he_thong_cai_dat_label'),
            isHeader: true,
        },
        {
            id: "pages",
            label: st('cau_hinh_he_thong_label'),
            icon: "ri-settings-5-line",
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setIsPages(!isPages);
                setIscurrentState('Pages');
                updateIconSidebar(e);
            },
            stateVariables: isPages,
            subItems: [
              
                // Audit Logs - ADDED
                // { 
                //     id: "auditLogs", 
                //     label: "Nhật ký Audit Logs", 
                //     link: "/audit-logs", 
                //     parentId: "pages",
                //     icon: "ri-file-list-3-line"
                // },
                // User Management - ADDED
                // { 
                //     id: "userManagement", 
                //     label: "Quản lý Tài khoản", 
                //     link: "/user-management", 
                //     parentId: "pages",
                //     icon: "ri-user-settings-line"
                // },
                // Role Management - ADDED
                // { 
                //     id: "roleManagement", 
                //     label: "Quản lý Nhóm quyền", 
                //     link: "/role-management", 
                //     parentId: "pages",
                //     icon: "ri-shield-user-line"
                // },
                // System Configuration - ADDED`n                { `n                    id: "systemConfiguration", `n                    label: "System Configuration", `n                    link: "/system-configuration", `n                    parentId: "pages",`n                    icon: "ri-settings-3-line"`n                },`n                // Agent Management - ADDED`n                { `n                    id: "agentManagement", `n                    label: "Agent Management", `n                    link: "/agent-management", `n                    parentId: "pages",`n                    icon: "ri-user-settings-line"`n                },
                                { 
                    id: "systemConfiguration", 
                    label: st('thong_tin_chung_label'), 
                    link: "/system-configuration", 
                    parentId: "pages",
                    icon: "ri-settings-3-line"
                },
                // Brand Management - ADDED
                { 
                    id: "brandManagement", 
                    label: st('quan_ly_thuong_hieu_label'), 
                    link: "/brand-management", 
                    parentId: "pages",
                    icon: "ri-palette-line"
                },
                                // Tenant Management - ADDED (DM Phòng / Chi nhánh)
                                { 
                                    id: "tenantManagement", 
                                    label: st('dm_phong_chi_nhanh_label'), 
                                    link: "/tenant-management", 
                                    parentId: "pages",
                                    icon: "ri-building-line"
                                },
                                                // Agent Management - ADDED (Quản lý Đại lý)
                                { 
                                    id: "agentManagement", 
                                    label: st('quan_ly_dai_ly_label'), 
                                    link: "/agent-management", 
                                    parentId: "pages",
                                    icon: "ri-user-star-line"
                                },
                                // Ticket Design Template - ADDED
                // { 
                //     id: "ticketDesignTemplate", 
                //     label: "Quản lý Mẫu Thiết kế Vé", 
                //     link: "/ticket-design-template", 
                //     parentId: "pages",
                //     icon: "ri-file-text-line"
                // },
                // Sinh Bộ Số & QR - ADDED
                // { 
                //     id: "sinhBoSoQr", 
                //     label: "Sinh Bộ Số & Mã QR", 
                //     link: "/sinh-bo-so-qr", 
                //     parentId: "pages",
                //     icon: "ri-qr-code-line"
                // }
            ],
        },

        {
            id: "roleManagement",
            label: st('quan_ly_nhom_quyen_label'),
            icon: "ri-team-line",
            link: "/role-management",
            click: function (e: any) {
                e.preventDefault();
                setIscurrentState('RoleManagement');
            }
        },
        {
            id: "moduleManagement",
            label: st('quan_ly_module_label'),
            icon: "ri-menu-2-line",
            link: "/module-management",
            click: function (e: any) {
                e.preventDefault();
                setIscurrentState('ModuleManagement');
            }
        },
        {
            id: "userManagement",
            label: st('quan_ly_tai_khoan_label'),
            icon: "ri-user-settings-line",
            link: "/user-management",
            click: function (e: any) {
                e.preventDefault();
                setIscurrentState('UserManagement');
            }
        },
        {
            id: "auditLogs",
            label: st('nhat_ky_he_thong_label'),
            icon: " ri-history-line",
            link: "/audit-logs",
            click: function (e: any) {
                e.preventDefault();
                setIscurrentState('AuditLogs');
            }
        },
        
    ];
    return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
